export const GET_WORKPLACES = 'GET_WORKPLACES';
export const GET_WORKPLACES_FAILED = 'GET_WORKPLACES_FAILED';
export const GET_WORKPLACES_SUCCESS = 'GET_WORKPLACES_SUCCESS';

export const SAVE_WORKPLACE = 'SAVE_WORKPLACE';
export const SAVE_WORKPLACE_FAILED = 'SAVE_WORKPLACE_FAILED';
export const SAVE_WORKPLACE_SUCCESS = 'SAVE_WORKPLACE_SUCCESS';
